import { ResponseBody } from '@gongxigames/framework/integrations/rubyplay/types';
import { RubyPlayGameClientWrapper } from '@gongxigames/framework/integrations/rubyplay/RubyPlayGameClientWrapper';

export type MultiSetsPromotionInitData = {
    initResponse: ResponseBody;
    clientWrapper: RubyPlayGameClientWrapper;
    defaultBet: number;
};
